import { useAtomValue } from 'jotai';
import { roleToVariationMappingAtom } from '../atoms';

export const useRoleVariation = () => useAtomValue(roleToVariationMappingAtom);
